function LoadingSpinner() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-ink-4 border-t-signal" />
        <p className="text-sm text-paper-dim">加载中...</p>
      </div>
    </div>
  );
}

export default LoadingSpinner;
